export default {"src":"/_next/static/media/apple-logo.d65f4b6f.svg","height":25,"width":20,"blurWidth":0,"blurHeight":0};